module.exports = __webpack_public_path__ + "img/interception_right.78dc3dfa.jpg";